"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButterLolBW = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("rect", { x: "2.0625", y: "2.0625", width: "19.875", height: "19.875", rx: "3.45536", fill: "#F5F5F5", stroke: "black", strokeWidth: strokeWidth }, void 0),
            jsx_runtime_1.jsx("path", { d: "M18.6145 10.5938C18.3286 14.0792 15.4092 16.8188 11.85 16.8188C8.29078 16.8188 5.37141 14.0792 5.08548 10.5938H18.6145Z", fill: "white", stroke: "black", strokeWidth: strokeWidth }, void 0),
            jsx_runtime_1.jsx("path", { d: "M10.2754 6.75L7.65039 7.40625", stroke: "black", strokeWidth: strokeWidth }, void 0),
            jsx_runtime_1.jsx("path", { d: "M13.4248 6.75L16.0498 7.40625", stroke: "black", strokeWidth: strokeWidth }, void 0)] }, void 0));
};
exports.ButterLolBW = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 24 24' });
//# sourceMappingURL=ButterLolBW.js.map